<template>
  <div class="blog-list-container">
    <RightList :list="tocWithSelect" @select="handleSelect" />
  </div>
</template>

<script>
import RightList from '../components/RightList';
import eventBus from '@/eventBus';
import bebounce from '@/utils/debounce'
export default {
  components: {
    RightList
  },
  data() {
    return {
      scrollY: 0,
      activeAnchor: ''
    }
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getCategoryId() {
      return this.$route.params.id
    },
    tocWithSelect() {
      const getToc = (toc = []) => {
        return toc.map(item => {
          return {
            ...item,
            isSelected: item.anchor === this.activeAnchor,
            children: getToc(item.children)
          }
        })
      };
      return getToc(this.list)
    },
    doms() {
      const domId = this.tocWithSelect;
      const dom = [];
      const getDom = (list) => {
        for (var i = 0; i < list.length; i++) {
          dom.push(document.getElementById(list[i].anchor));
          getDom(list[i].children)
        }
      }
      getDom(domId)
      return dom
      // const doms = []
      // const getdoms = (list) => {
      //   for (var i = 0; i < list.length; i++) {
      //     //  return doms.push(document.getElementById(list.anchor));
      //     return list
      //   }
      // }
      // getdoms(this.tocWithSelect)
      // return doms
    },
  },
  mounted() {
    this.debounceIsActice = bebounce(this.isActive)
    eventBus.$on('mainScroll', this.debounceIsActice);
    eventBus.$on('handleAnchor', this.handleAnchorChange);
  },
  destroyed() {
    eventBus.$off('mainScroll', this.debounceIsActice);
    eventBus.$off('handleAnchor', this.handleAnchorChange);
  },
  methods: {
    handleSelect(item) {
      location.hash = item;
    },
    isActive(dom) {
      if (!dom) { //如果正在滚动的dom已经销毁 不做处理
        return
      }
      for (var i = 0; i < this.doms.length; i++) {
        const CurdomTop = this.doms[i].getBoundingClientRect().top;
        if (!this.doms[i]) {
          continue;
        }
        if (CurdomTop >= 0 && CurdomTop <= 200) {
          this.activeAnchor = this.doms[i].id;
          return;
        } else if (CurdomTop >= 200) {  //滚动条在元素的上方
          return;
        } else {//滚动条在元素的下方
          this.activeAnchor = this.doms[i].id;
        }
      }
    },
    handleAnchorChange(anchor) {
      this.activeAnchor = anchor
    }
  }
}
</script>

<style scoped lang="less">
.blog-list-container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;

  // overflow-y: scroll;
  .right-list-container {
    width: 100%;
    height: 100%;
  }
}
</style>